









































































































































import { defineComponent, ref } from '@vue/composition-api';
import moment from 'moment';
import { IHSCode } from '@/models';
import { useFetchHSCodes, useDeleteHSCode } from '@/composable/hs-codes';
import authMixin from '@/mixins/auth';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import HSCodeFormDialog from '@/components/harmonized-system/HSCodeFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import HSCodeUploadFileDialog from '@/components/harmonized-system/HSCodeUploadFileDialog.vue';

export default defineComponent({
  name: 'HSCodeListPage',
  mixins: [authMixin],
  components: {
    ALPage,
    ConfirmationDialog,
    ErrorAlert,
    HSCodeFormDialog,
    HSCodeUploadFileDialog
  },
  setup(_) {
    //We use a separate ref for the search model in order to not update the queryKey once the search is updated
    const currentSearch = ref<string>('');

    const headers = [
      { text: '#', value: 'index', sortable: false, width: 5 },
      { text: 'Code', value: 'code', sortable: false },
      { text: 'Description', value: 'description', sortable: false },
      { text: '', value: 'actions', sortable: false, width: 100 }
    ];

    const dialog = ref(false);
    const selectedHSCode = ref<IHSCode | null>(null);

    function openHSCodeDialog(hsCode?: IHSCode) {
      dialog.value = true;
      selectedHSCode.value = hsCode ?? null;
    }

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deleteHSCode,
      reset: deleteReset
    } = useDeleteHSCode();

    const deleteDialog = ref(false);
    function openDeleteHSCodeDialog(hsCode: IHSCode) {
      selectedHSCode.value = hsCode;
      deleteDialog.value = true;
    }

    function closeDrawerAndDialog() {
      drawer.value = false;
      deleteDialog.value = false;
    }

    function removeHSCode(hsCode: IHSCode) {
      deleteHSCode(hsCode.code!, {
        onSuccess: () => {
          closeDrawerAndDialog();
        }
      });
    }

    function clearAllErrors() {
      deleteReset();
      error.value = null;
    }

    const { hsCodes, error, isLoading } = useFetchHSCodes();

    const drawer = ref(false);
    function openHSCodeDrawer(hsCode: IHSCode) {
      selectedHSCode.value = hsCode;
      drawer.value = true;
    }

    return {
      deleteInProgress,
      deleteDialog,
      deleteError,
      drawer,
      selectedHSCode,
      moment,
      dialog,
      currentSearch,
      hsCodes,
      isLoading,
      headers,
      error,
      openHSCodeDialog,
      clearAllErrors,
      openDeleteHSCodeDialog,
      openHSCodeDrawer,
      closeDrawerAndDialog,
      removeHSCode
    };
  }
});
